import React from 'react';
import Spinner from './../../../../CommonComponents/Spinner/Spinner';
import './CancelReturnPopup.scss';
import LKModal from '../../../components/Modal/Modal';

const CancelReturnPopup = props => {
  const {
    isCancellable,
    cancelReturnPopupToggle,
    confirmCancelReturn,
    chatWithUs,
    showCancelReturnPopup,
    returnCancelLoading,
    dataLocale: {
      CHAT_WITH_US,
      NEED_HELP,
      OK,
      RETURN_COULD_NOT_BE_CANCELLED,
      NO_DONT_CANCEL,
      YES_PROCEED_WITH_CANCELLATION,
      CANCEL_RETURN,
      QUESTION_MARK,
      THE_EXCHANGE_REFUND_WILL_BE_CANCELLED,
    },
  } = props;
  return (
    <LKModal
      backdrop
      expanded
      className="cancel-popup"
      hideHandler={cancelReturnPopupToggle}
      showModal={showCancelReturnPopup}
      size="small"
    >
      {returnCancelLoading && <Spinner fullpage />}
      <div className="pd-15 text-center" role="dialog">
        {isCancellable ? (
          <React.Fragment>
            <div className="pd-t15 pd-b10 fw500 fs20 margin-b18">
              {CANCEL_RETURN} {QUESTION_MARK}
            </div>
            <div className="mr-b15 fs14 margin-b12 lh-20 pd-l20 pd-r20 text-color-grey mr-b25">
              {THE_EXCHANGE_REFUND_WILL_BE_CANCELLED} {QUESTION_MARK}
            </div>
            <div
              className="text-uppercase new-btn margin-b7 cursor-pointer padding-t6 padding-b6 border-radius4 padding-2 fsp13 fw500 lh-20 text-color_white  bg-topaz mr-b12"
              onClick={confirmCancelReturn}
            >
              {YES_PROCEED_WITH_CANCELLATION}
            </div>
            <div
              className="dont-cancel text-uppercase cursor-pointer pd-10 fsp13 fw500 lh-20 text-topaz bora-4"
              onClick={cancelReturnPopupToggle}
            >
              {NO_DONT_CANCEL}
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <div className="padding-t15 padding-b10 fs16 fw600 fsp16">
              {RETURN_COULD_NOT_BE_CANCELLED}
            </div>
            <div className="mr-b15 lh-20 pd-l20 fs14 pd-r20 text-color-grey mr-b25">
              {NEED_HELP} {QUESTION_MARK}
            </div>
            <div className="action-btn display-flex mr-b5 justify-space-between">
              <span
                className="dont-cancel text-uppercase fs14 pd-10 block fsp13 fw500 lh-20 text-topaz bora-4"
                onClick={chatWithUs}
              >
                {CHAT_WITH_US}
              </span>
              <span
                className="text-uppercase new-btn pd-10 fs14 fsp13 fw500 lh-20 text-color_white bg-topaz"
                onClick={cancelReturnPopupToggle}
              >
                {OK}
              </span>
            </div>
          </React.Fragment>
        )}
      </div>
    </LKModal>
  );
};

export default CancelReturnPopup;
